import React, { SVGProps } from 'react'
const SvgUsers03 = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={17}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      stroke={props.stroke || 'var(--color-cta)'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.333}
      d="M12 10.891c.97.488 1.803 1.27 2.41 2.249.12.194.18.29.201.425a.72.72 0 0 1-.398.715c-.125.054-.265.054-.546.054m-3-6.312a3 3 0 0 0 0-5.377M9.333 5.334a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-7.627 7.625c1.063-1.596 2.74-2.625 4.627-2.625s3.565 1.03 4.627 2.625c.233.35.35.524.336.748a.74.74 0 0 1-.263.492c-.178.135-.424.135-.915.135h-7.57c-.49 0-.736 0-.914-.135a.74.74 0 0 1-.264-.492c-.013-.224.103-.398.336-.748"
    />
  </svg>
)
export default SvgUsers03
